import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { initHomeEffects, toast } from "@/lib/homeEffects";
import { useEjercicio } from "@/context/EjercicioContext";
import { api } from "@/lib/api";
import "@/daelpaso.css";

const QS = [
  { t: "¿Qué cambio llevas tiempo posponiendo?", h: "Nómbralo como se lo contarías a una amiga. No hace falta que esté bien escrito.", ex: ["Cambiar de trabajo", "Poner un límite", "Empezar mi proyecto"], max: 500, key: "cambio", err: "Escribe aunque sea una frase para poder seguir." },
  { t: "¿Qué hace importante este cambio para ti ahora?", h: "Piensa en qué pasaría si dentro de un año siguieras igual.", ex: ["Me siento estancada", "Quiero recuperar mi tiempo", "Ya no me reconozco"], max: 500, key: "importancia", err: "Una frase basta. Lo importante es que sea tuya." },
  { t: "¿Cuál es el paso más pequeño que depende de ti y podrías dar en las próximas 72 horas?", h: "Que sea tan pequeño que no puedas decirte que no: una llamada, un correo, una hora en la agenda.", ex: ["Actualizar mi CV", "Escribir a una persona", "Reservar una hora el sábado"], max: 300, key: "primer_paso", err: "Elige una acción concreta, aunque sea mínima." },
];

const scrollToId = (id) => {
  const t = document.getElementById(id);
  if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 72, behavior: "smooth" });
};

function ExerciseCard() {
  const { data, update } = useEjercicio();
  const [cur, setCur] = useState(0);
  const [err, setErr] = useState("");
  const [saved, setSaved] = useState(false);
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [err2, setErr2] = useState("");
  const [savedLead, setSavedLead] = useState(!!data.leadId);
  const saveT = useRef();

  const vals = [data.cambio, data.importancia, data.primer_paso];
  const Q = QS[cur];

  const onInput = (e) => {
    const v = e.target.value.slice(0, Q.max);
    update({ [Q.key]: v });
    setErr(""); setSaved(false);
    clearTimeout(saveT.current);
    saveT.current = setTimeout(() => { if (v.trim()) setSaved(true); }, 700);
  };

  const next = () => {
    if (!vals[cur].trim()) { setErr(Q.err); return; }
    setCur(cur + 1);
  };

  const saveLead = async () => {
    if (!/^\S+@\S+\.\S+$/.test(email.trim())) { setErr2("Revisa el email: parece incompleto."); return; }
    if (!consent) { setErr2("Marca la casilla para poder enviarte tu paso."); return; }
    setErr2("");
    const res = await api.crearLead({
      nombre: email.trim().split("@")[0],
      email: email.trim(),
      cambio: data.cambio, importancia: data.importancia, primer_paso: data.primer_paso,
      consentimiento: true,
    });
    if (res.ok) { update({ leadId: res.data.id }); setSavedLead(true); toast("Tu paso está guardado. Te lo enviamos por email."); }
    else setErr2(res.error);
  };

  return (
    <div className="ex-card fd" id="exCard">
      <div className="ex-top">
        <span>{cur < 3 ? `Paso ${cur + 1} de 3` : "Listo"}</span>
        <span className={`saved${saved ? " on" : ""}`}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12l5 5L20 7" /></svg>Guardado
        </span>
      </div>
      <div className="seg" aria-hidden="true">
        <i className={cur > 0 || cur === 3 ? "done" : ""} />
        <i className={cur > 1 || cur === 3 ? "done" : ""} />
        <i className={cur > 2 || cur === 3 ? "done" : ""} />
      </div>
      <div className="q" aria-live="polite">
        {cur < 3 ? (
          <div className="q-in" key={cur}>
            <h3>{Q.t}</h3>
            <p className="help">{Q.h}</p>
            <label htmlFor="ans">Tu respuesta</label>
            <textarea id="ans" data-testid="ex-answer" maxLength={Q.max} placeholder="Escribe aquí…" value={vals[cur]} onChange={onInput} autoFocus />
            <div className="q-foot">
              <div className="chips-hint">
                {Q.ex.map((x) => (
                  <button type="button" key={x} onClick={() => { update({ [Q.key]: x }); setSaved(true); }}>{x}</button>
                ))}
              </div>
              <span>{vals[cur].length}/{Q.max}</span>
            </div>
            <p className="err" role="alert" data-testid="ex-error">{err}</p>
            <div className="ex-actions">
              <button className="back" type="button" disabled={cur === 0} onClick={() => setCur(cur - 1)}>← Atrás</button>
              <button className="btn btn-p" type="button" data-testid="ex-next" onClick={next}>{cur === 2 ? "Definir mi paso" : "Seguir"} <span className="ar" /></button>
            </div>
          </div>
        ) : savedLead ? (
          <div className="q-in">
            <div className="result">
              <p className="eyebrow">Tu primer paso · próximas 72 h</p>
              <h3 data-testid="ex-result">{data.primer_paso}</h3>
            </div>
            <p className="lead" style={{ marginTop: 20 }}>Ya has dejado de pensarlo solo en tu cabeza. Tienes un primer paso concreto.</p>
            <div className="ex-actions">
              <button className="back" type="button" onClick={() => { update({ cambio: "", importancia: "", primer_paso: "", leadId: null }); setSavedLead(false); setCur(0); setEmail(""); setConsent(false); }}>Empezar de nuevo</button>
              <button className="btn btn-p" type="button" onClick={() => scrollToId("mi-espacio")}>Ir a mi espacio <span className="ar" /></button>
            </div>
          </div>
        ) : (
          <div className="q-in">
            <div className="result">
              <p className="eyebrow">Tu primer paso · próximas 72 h</p>
              <h3 data-testid="ex-result">{data.primer_paso}</h3>
              <dl>
                <div><dt>El cambio</dt><dd>{data.cambio}</dd></div>
                <div><dt>Por qué ahora</dt><dd>{data.importancia}</dd></div>
              </dl>
            </div>
            <label htmlFor="em">Recíbelo por email</label>
            <input id="em" type="email" data-testid="ex-email" placeholder="tu@email.com" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)}
              style={{ width: "100%", marginTop: 8, background: "var(--bg-2)", border: "1px solid var(--line)", borderRadius: 12, padding: 14, color: "var(--text)", font: "400 16px var(--body)" }} />
            <label style={{ display: "flex", gap: 10, alignItems: "flex-start", fontWeight: 400, marginTop: 14, color: "var(--muted)" }}>
              <input type="checkbox" data-testid="ex-consent" checked={consent} onChange={(e) => setConsent(e.target.checked)} style={{ marginTop: 4, accentColor: "var(--alba)" }} />
              Doy mi permiso para guardar estos datos y recibir mi ejercicio.
            </label>
            <p className="err" role="alert" data-testid="ex-error2">{err2}</p>
            <div className="ex-actions" style={{ flexWrap: "wrap" }}>
              <button className="back" type="button" onClick={() => setCur(2)}>← Atrás</button>
              <button className="btn btn-g" type="button" data-testid="ex-guardar" onClick={saveLead}>Guardar mi paso</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function fmtDay(d) {
  return d.toLocaleDateString("es-ES", { weekday: "short", day: "numeric", month: "short" }).replace(".", "");
}

function Booking() {
  const { data, update } = useEjercicio();
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [monthIdx, setMonthIdx] = useState(0);
  const [selDay, setSelDay] = useState(null);
  const [selISO, setSelISO] = useState(null);
  const [co, setCo] = useState(null); // null | {step}
  const [coErr, setCoErr] = useState("");
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [terms, setTerms] = useState(false);
  const [pm, setPm] = useState("Tarjeta");
  const [done, setDone] = useState(null);
  const [bookErr, setBookErr] = useState("");

  const load = useCallback(async () => {
    setLoading(true); setBookErr("");
    const res = await api.disponibilidad();
    setLoading(false);
    if (res.ok) setSlots(res.data.slots);
    else setBookErr(res.error);
  }, []);
  useEffect(() => { load(); }, [load]);

  // agrupar por día local
  const byDay = {};
  slots.forEach((iso) => {
    const d = new Date(iso);
    const key = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
    (byDay[key] = byDay[key] || []).push({ iso, label: d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" }) });
  });
  const months = [...new Set(slots.map((iso) => { const d = new Date(iso); return `${d.getFullYear()}-${d.getMonth()}`; }))]
    .map((m) => m.split("-").map(Number));
  const cm = months[monthIdx] || [new Date().getFullYear(), new Date().getMonth()];
  const [cy, cmo] = cm;
  const first = new Date(cy, cmo, 1);
  const daysIn = new Date(cy, cmo + 1, 0).getDate();
  const off = (first.getDay() + 6) % 7;
  const cells = [];
  for (let i = 0; i < off; i++) cells.push(null);
  for (let d = 1; d <= daysIn; d++) cells.push(d);

  const dayKey = (d) => `${cy}-${cmo}-${d}`;
  const selDayTimes = selDay ? (byDay[dayKey(selDay)] || []) : [];

  const openCheckout = () => {
    if (!selISO) { toast("Elige día y hora de tu primera sesión."); return; }
    setNombre(""); setEmail(""); setTerms(false); setCoErr(""); setCo({ step: 0 });
  };

  const coNext = async () => {
    if (co.step === 0) {
      if (!nombre.trim()) { setCoErr("Escribe tu nombre."); return; }
      if (!/^\S+@\S+\.\S+$/.test(email.trim())) { setCoErr("Revisa tu email: parece incompleto."); return; }
      setCoErr(""); setCo({ step: 1 }); return;
    }
    if (co.step === 1) {
      if (!terms) { setCoErr("Acepta las condiciones para continuar."); return; }
      setCoErr("");
      let leadId = data.leadId;
      if (!leadId) {
        const res = await api.crearLead({
          nombre: nombre.trim(), email: email.trim(),
          cambio: data.cambio || "Pendiente de concretar en la sesión",
          importancia: data.importancia || "Pendiente de concretar en la sesión",
          primer_paso: data.primer_paso || "Pendiente de concretar en la sesión",
          consentimiento: true,
        });
        if (!res.ok) { setCoErr(res.error); return; }
        leadId = res.data.id; update({ leadId });
      }
      const sr = await api.crearSolicitud({ lead_id: leadId, fecha_sesion: selISO });
      if (!sr.ok) { setCoErr(sr.error); if (sr.error.includes("disponible")) { load(); setSelISO(null); } return; }
      const d = new Date(selISO);
      setDone(`${fmtDay(d)} · ${d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}`);
      setCo({ step: 2 });
    }
  };

  return (
    <section className="sec" id="reservar">
      <div className="wrap">
        <p className="eyebrow fd">Reserva</p>
        <h2 className="rv" style={{ marginTop: 18 }}><span className="ln"><span>Tres sesiones 1 a 1.</span></span><span className="ln"><span><em>Un pago, sin sorpresas.</em></span></span></h2>
        <div className="shop">
          <div className="prod fd">
            <p className="eyebrow">El acompañamiento</p>
            <h3 style={{ marginTop: 14 }}>Da el Paso · 3 sesiones</h3>
            <p className="lead">Un acompañamiento para dejar de postergar un cambio vital y empezar a actuar. Ampliable si lo necesitas.</p>
            <ul className="incl">
              {["3 sesiones individuales con Patricia", "Tu ejercicio de claridad como punto de partida", "Un paso concreto después de cada sesión", "Opción de ampliar si lo necesitas"].map((t) => (
                <li key={t}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12l5 5L20 7" /></svg><span>{t}</span></li>
              ))}
            </ul>
            <div className="pick">
              <p className="pick-l">Elige día y hora de tu primera sesión</p>
              {loading ? (
                <p className="lead" style={{ marginTop: 16 }} data-testid="booking-loading">Comprobando disponibilidad…</p>
              ) : bookErr ? (
                <div style={{ marginTop: 16 }} data-testid="booking-error">
                  <p className="lead" style={{ color: "var(--crit)" }}>{bookErr}</p>
                  <button className="mini" type="button" style={{ marginTop: 12 }} data-testid="booking-retry" onClick={load}>Reintentar</button>
                </div>
              ) : slots.length === 0 ? (
                <p className="lead" style={{ marginTop: 16 }} data-testid="booking-empty">La agenda estará disponible muy pronto. Si quieres empezar antes, escríbeme por WhatsApp o llámame y lo organizamos juntas.</p>
              ) : (
                <div className="book">
                  <div className="cal">
                    <div className="cal-h">
                      <button type="button" className="cal-nav" aria-label="Mes anterior" disabled={monthIdx === 0} onClick={() => { setMonthIdx(Math.max(0, monthIdx - 1)); setSelDay(null); }}>‹</button>
                      <b>{first.toLocaleDateString("es-ES", { month: "long", year: "numeric" })}</b>
                      <button type="button" className="cal-nav" aria-label="Mes siguiente" disabled={monthIdx >= months.length - 1} onClick={() => { setMonthIdx(Math.min(months.length - 1, monthIdx + 1)); setSelDay(null); }}>›</button>
                    </div>
                    <div className="cal-w" aria-hidden="true"><span>L</span><span>M</span><span>X</span><span>J</span><span>V</span><span>S</span><span>D</span></div>
                    <div className="cal-g" role="grid" data-testid="booking-calendar">
                      {cells.map((d, i) => d && byDay[dayKey(d)] ? (
                        <button key={dayKey(d)} type="button" aria-pressed={selDay === d} aria-label={`día ${d}`} data-testid={`booking-day-${d}`} onClick={() => { setSelDay(d); setSelISO(null); }}>{d}</button>
                      ) : (<span key={`blank-${i}`}>{d || ""}</span>))}
                    </div>
                  </div>
                  <div>
                    <p className="times-l">{selDay ? `Horas · ${fmtDay(new Date(cy, cmo, selDay))}` : "Elige un día para ver las horas"}</p>
                    <div className="times" data-testid="booking-times">
                      {selDayTimes.map((t) => (
                        <button key={t.iso} type="button" aria-pressed={selISO === t.iso} data-testid={`booking-time-${t.iso}`} onClick={() => setSelISO(t.iso)}>{t.label}</button>
                      ))}
                    </div>
                    <p className="ex-note">Esta conversación sirve para entender dónde estás y qué necesitas para avanzar.</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          <aside className="sum">
            <p className="eyebrow">Resumen</p>
            <div className="price"><b>150</b><span>€ · pago único</span></div>
            <div className="rows">
              <div><span>Formato</span><span>3 sesiones 1 a 1</span></div>
              <div><span>Primera sesión</span><span>{selISO ? `${fmtDay(new Date(selISO))} · ${new Date(selISO).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}` : "Elige día y hora"}</span></div>
              <div><span>Ampliación</span><span>Si lo necesitas</span></div>
            </div>
            {slots.length > 0 && (
              <>
                <button className="btn btn-p" type="button" data-testid="booking-reservar" onClick={openCheckout}>Reservar y pagar <span className="ar" /></button>
                <div className="pay"><span>Pago simulado</span><span>Sin cobro real</span></div>
                <div className="assure">
                  <div><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12l5 5L20 7" /></svg><span>El cobro real llega en una próxima versión. Tu solicitud queda registrada.</span></div>
                </div>
              </>
            )}
            <a
              className="btn btn-g"
              style={{ width: "100%", justifyContent: "center", marginTop: 16 }}
              href="https://wa.me/34660426714?text=Hola%20Patricia.%20Te%20escribo%20en%20referencia%20a%20tu%20acompa%C3%B1amiento%20Da%20el%20Paso!"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-btn"
            >
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M17.5 14.4c-.3-.2-1.7-.8-2-.9-.3-.1-.5-.2-.7.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-1.6-.8-2.7-1.5-3.8-3.4-.3-.5.3-.5.8-1.5.1-.2 0-.4 0-.5 0-.2-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.2 3.3 5.2 4.6 2 .8 2.7.9 3.7.8.6-.1 1.7-.7 2-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3Z"/><path d="M12 2a10 10 0 0 0-8.6 15l-1.3 4.8 4.9-1.3A10 10 0 1 0 12 2Zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-2.9.8.8-2.8-.2-.3A8.2 8.2 0 1 1 12 20.2Z"/></svg>
              Escríbeme por WhatsApp
            </a>
            <p className="ex-note" style={{ textAlign: "center" }}>
              o llámame: <a href="tel:+34660426714" style={{ color: "var(--alba-text)" }}>+34 660 42 67 14</a>
            </p>
          </aside>
        </div>
      </div>

      {co && (
        <div className="modal" role="dialog" aria-modal="true">
          <div className="modal-bg" onClick={() => setCo(null)} />
          <div className="modal-c">
            <div className="co-h">
              <div>
                <p className="eyebrow">Paso {co.step + 1} de 3 · {["Tus datos", "Pago", "Confirmación"][co.step]}</p>
                <p className="co-sum">3 sesiones 1 a 1 · 150 €{selISO ? ` · ${fmtDay(new Date(selISO))} · ${new Date(selISO).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}` : ""}</p>
              </div>
              <button className="mclose" type="button" aria-label="Cerrar" onClick={() => setCo(null)}>×</button>
            </div>
            <div className="co-seg"><i className={co.step >= 0 ? "done" : ""} /><i className={co.step >= 1 ? "done" : ""} /><i className={co.step >= 2 ? "done" : ""} /></div>

            {co.step === 0 && (
              <div className="q-in">
                <div className="f2">
                  <div><label htmlFor="cn">Nombre</label><input id="cn" data-testid="co-nombre" value={nombre} maxLength={80} onChange={(e) => setNombre(e.target.value)} /></div>
                  <div><label htmlFor="ce">Email</label><input id="ce" type="email" data-testid="co-email" value={email} maxLength={160} onChange={(e) => setEmail(e.target.value)} /></div>
                </div>
              </div>
            )}
            {co.step === 1 && (
              <div className="q-in">
                <div className="pm-g">
                  {["Tarjeta", "Bizum"].map((m) => (
                    <label className="pm-o" key={m}><input type="radio" name="pm" checked={pm === m} onChange={() => setPm(m)} /> {m}</label>
                  ))}
                </div>
                <div className="stripe">Pago simulado en esta versión. No se realiza ningún cargo; tu solicitud de sesión queda registrada para Patricia.</div>
                <label className="tick"><input type="checkbox" data-testid="co-terms" checked={terms} onChange={(e) => setTerms(e.target.checked)} /> Acepto las condiciones y la política de privacidad.</label>
              </div>
            )}
            {co.step === 2 && (
              <div className="q-in" data-testid="co-done">
                <h3 style={{ fontSize: 30, marginTop: 10 }}>Tu solicitud está registrada.</h3>
                <p className="lead" style={{ marginTop: 12 }}>Primera sesión: {done}. Te enviaríamos la confirmación a {email}.</p>
                <div className="ex-actions" style={{ marginTop: 20 }}>
                  <span />
                  <button className="btn btn-p" type="button" onClick={() => { setCo(null); scrollToId("mi-espacio"); }}>Ir a mi espacio <span className="ar" /></button>
                </div>
              </div>
            )}

            {co.step < 2 && (
              <>
                <p className="err" role="alert" data-testid="co-error">{coErr}</p>
                <div className="ex-actions">
                  <button className="back" type="button" disabled={co.step === 0} onClick={() => setCo({ step: co.step - 1 })}>← Atrás</button>
                  <button className="btn btn-p" type="button" data-testid="co-next" onClick={coNext}>{co.step === 0 ? "Continuar al pago" : "Confirmar reserva"} <span className="ar" /></button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </section>
  );
}

export default function Home() {
  const [menuOpen, setMenuOpen] = useState(false);
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("js");
    if (!document.documentElement.dataset.theme) document.documentElement.dataset.theme = (typeof localStorage !== "undefined" && localStorage.getItem("dep-theme")) || "dark";
  }
  useLayoutEffect(() => {
    // Efecto de montaje único: inicializa loader, niebla y animaciones una sola vez.
    const cleanup = initHomeEffects();
    return cleanup;
  }, []);

  return (
    <>
      {/* LOADER */}
      <div className="loader open" id="loader" aria-hidden="true">
        <div className="loader-m"><span className="a">Da el</span><span className="loader-gap"><i /><i /><i /></span><span className="b">Paso</span></div>
        <div className="loader-n"><span id="ldLabel">Lo que siento</span><span id="ldNum">00</span></div>
      </div>

      {/* NAV */}
      <header className="nav" id="nav">
        <div className="wrap">
          <a href="#top" className="logo"><span className="paso-dot" />Da el <em>Paso</em></a>
          <nav className="nav-l">
            <a className="ul" href="#metodo">Método</a>
            <a className="ul" href="#ejercicio">Ejercicio</a>
            <a className="ul" href="#reservar">Reservar</a>
            <a className="ul" href="#faq">Preguntas</a>
          </nav>
          <div className="nav-r">
            <button className="tg" id="themeBtn" data-testid="themeBtn" type="button" aria-label="Cambiar tema">
              <svg className="moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" /></svg>
              <svg className="sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5 19 19M19 5l-1.5 1.5M6.5 17.5 5 19" /></svg>
            </button>
            <a className="btn btn-p" href="#reservar">Reservar <span className="ar" /></a>
            <button className="nav-burger" type="button" aria-label={menuOpen ? "Cerrar menú" : "Abrir menú"} aria-expanded={menuOpen} data-testid="nav-burger" onClick={() => setMenuOpen((v) => !v)}>
              {menuOpen ? (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M6 6l12 12M18 6 6 18" /></svg>
              ) : (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
              )}
            </button>
          </div>
        </div>
        <div className={`nav-mobile${menuOpen ? " open" : ""}`} data-testid="nav-mobile">
          <a href="#metodo" onClick={() => setMenuOpen(false)}>Método</a>
          <a href="#ejercicio" onClick={() => setMenuOpen(false)}>Ejercicio</a>
          <a href="#reservar" onClick={() => setMenuOpen(false)}>Reservar</a>
          <a href="#faq" onClick={() => setMenuOpen(false)}>Preguntas</a>
          <a className="btn btn-p" href="#reservar" onClick={() => setMenuOpen(false)}>Reservar 3 sesiones <span className="ar" /></a>
        </div>
      </header>

      <main id="top">
        {/* HERO */}
        <section className="hero" id="hero">
          <div className="dawn" aria-hidden="true"><div className="dawn-word">claridad</div><div className="dawn-note">Lo que aparece cuando ordenas el ruido</div></div>
          <div className="fog" id="fog" aria-hidden="true" />
          <div className="wrap hero-c">
            <p className="eyebrow fd" data-intro>Da el Paso · by Patricia Leung</p>
            <h1 className="rv" data-intro style={{ marginTop: 22 }}>
              <span className="ln"><span>Deja de posponer</span></span>
              <span className="ln"><span>ese cambio.</span></span>
              <span className="ln"><span><em>Da el primer paso.</em></span></span>
            </h1>
            <p className="lead fd" data-intro>Si sabes que algo tiene que cambiar pero sigues dándole vueltas, empieza por ordenar lo que estás viviendo. Tres preguntas, tres minutos, sin compromiso.</p>
            <div className="hero-ctas fd" data-intro>
              <a className="btn btn-p mag" href="#ejercicio" data-testid="hero-ejercicio">Haz el ejercicio gratis <span className="ar" /></a>
            </div>
            <div className="hero-meta fd" data-intro><span>3 sesiones 1 a 1</span><span>Pago único</span><span>Ampliable si lo necesitas</span></div>
          </div>
          <button className="hint" id="clearBtn" type="button"><span>Mueve el cursor<br />y despeja la niebla</span><span className="cue"><i /></span></button>
        </section>

        {/* PARA TI */}
        <section className="sec fit" id="para-ti">
          <div className="wrap">
            <p className="eyebrow fd">Para quién es</p>
            <h2 className="rv" style={{ marginTop: 18 }}><span className="ln"><span>Es para ti si te</span></span><span className="ln"><span><em>reconoces aquí.</em></span></span></h2>
            <div className="fit-grid">
              <ul className="fit-list">
                {["No sabes aún qué quieres pero tienes claro que algo tiene que cambiar.",
                  "Sabes lo que quieres pero sigues en el mismo punto de siempre.",
                  "Acumulas lecturas, cursos, reflexión y entendimiento pero sigues sin actuar.",
                  "Sigues posponiendo sin saber muy bien por qué.",
                  "Quieres salir del piloto automático y tomar las riendas de tu vida."].map((t) => <li className="fd" key={t}>{t}</li>)}
              </ul>
            </div>
          </div>
        </section>

        {/* EJERCICIO */}
        <section className="sec" id="ejercicio">
          <div className="wrap ex">
            <div>
              <p className="eyebrow fd">Ejercicio de claridad · gratis</p>
              <h2 className="rv" style={{ marginTop: 18 }}><span className="ln"><span>Empieza aquí,</span></span><span className="ln"><span><em>en tres minutos.</em></span></span></h2>
              <p className="lead fd" style={{ marginTop: 20 }}>Responde con lo que ahora mismo sea verdad para ti. Al final tendrás tu primer paso escrito y podrás recibirlo por email.</p>
              <div className="ex-why fd">
                <div><b>Sin registro</b><span>Solo pedimos tu email al final, si quieres guardar tu paso.</span></div>
                <div><b>Se guarda solo</b><span>Puedes cerrar la página y retomar donde lo dejaste.</span></div>
                <div><b>Después</b><span>Si quieres sostener ese paso, puedes reservar las 3 sesiones con Patricia.</span></div>
              </div>
            </div>
            <ExerciseCard />
          </div>
        </section>

        {/* MÉTODO */}
        <section className="sec" id="metodo">
          <div className="wrap method">
            <div className="method-l">
              <p className="eyebrow fd">Cómo funciona</p>
              <h2 className="rv" style={{ marginTop: 18 }}><span className="ln"><span>Un método corto,</span></span><span className="ln"><span><em>hecho para actuar.</em></span></span></h2>
              <p className="lead fd">Tres sesiones con Patricia, cada una tiene un objetivo claro.</p>
            </div>
            <div className="steps">
              {[["1", "Detente y escucha", "Haces una pausa para ver con claridad lo que estás viviendo, sin la presión de decidir todavía.", "Sesión 1"],
                ["2", "Ordena y elige", "Separas el ruido de lo importante y eliges hacia dónde quieres ir.", "Sesión 2"],
                ["3", "Da el paso y sostenlo", "Conviertes la claridad en una acción concreta que depende de ti, y preparas cómo mantenerla.", "Sesión 3"]].map(([n, t, p, tag]) => (
                <article className="step fd" key={n}><span className="n">{n}</span><div><h3>{t}</h3><p>{p}</p><span className="tag">{tag}</span></div></article>
              ))}
            </div>
          </div>
        </section>

        {/* PATRICIA */}
        <section className="sec" id="patricia" style={{ paddingTop: 0 }}>
          <div className="wrap guide">
            <div className="portrait" data-par="-40">
              <img src="/patricia.jpg" alt="Retrato de Patricia" loading="lazy" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
              <div className="ph"><span>Patricia</span><span>Da el Paso</span></div>
            </div>
            <div>
              <p className="eyebrow fd">Quién te acompaña</p>
              <p className="lead fd" style={{ marginTop: 20 }}>Soy Coach Ontológica, Life Coach e instructora de mindfulness e inteligencia emocional. Mi pasión por el desarrollo personal nació mucho antes que Da el Paso: de mi propia inquietud por crecer, conocerme y aprender a afrontar los cambios que la vida me ha ido poniendo delante.</p>
              <p className="lead fd" style={{ marginTop: 16 }}>Mi trayectoria profesional comenzó en la educación —soy profesora de Educación Primaria— y con los años fui profundizando en el desarrollo personal, el coaching y el mindfulness.</p>
              <p className="lead fd" style={{ marginTop: 16 }}>Pero Da el Paso no nace solo de lo que he estudiado. Nace también de lo que he vivido y de una convicción que ha ido creciendo conmigo: podemos pasar mucho tiempo sabiendo que queremos algo diferente y, aun así, seguir posponiendo la decisión de hacerlo.</p>
              <p className="lead fd" style={{ marginTop: 16 }}>Hoy acompaño a mujeres que están precisamente en ese momento: saben que hay algo que quieren cambiar, pero todavía no han dado el paso.</p>
              <blockquote className="fd">No estoy aquí para decirte qué decisión tomar. Estoy aquí para ayudarte a escucharte, ordenar lo que quieres y convertirlo en un primer paso concreto.</blockquote>
            </div>
          </div>
        </section>

        {/* RESERVA */}
        <Booking />

        {/* MI ESPACIO */}
        <section className="sec fit" id="mi-espacio">
          <div className="wrap">
            <div className="path-head">
              <div>
                <p className="eyebrow fd">Después de reservar · área privada</p>
                <h2 className="rv" style={{ marginTop: 18 }}><span className="ln"><span>Tu proceso,</span></span><span className="ln"><span><em>en un solo sitio.</em></span></span></h2>
              </div>
              <p className="lead fd">Cada clienta tiene su espacio: ve sus sesiones, marca su paso de 72 horas y guarda sus notas. Vista previa con datos de ejemplo.</p>
            </div>
            <div className="space fd">
              <div className="sp-col">
                <p className="sp-t">Mi proceso</p>
                <ol className="sess">
                  <li className="done"><b>Sesión 1 · Detente y escucha</b><span>Completada</span></li>
                  <li className="next"><b>Sesión 2 · Ordena y elige</b><span>Próxima · por confirmar</span></li>
                  <li><b>Sesión 3 · Da el paso y sostenlo</b><span>Pendiente de fijar</span></li>
                </ol>
              </div>
              <div className="sp-col">
                <p className="sp-t">Mi paso de 72 horas</p>
                <div className="mystep">
                  <p className="ms-q">“Actualizar mi CV y enviarlo a una persona de confianza.”</p>
                  <div className="ms-bar"><i style={{ width: "33%" }} /></div>
                  <label className="tick"><input type="checkbox" defaultChecked /> Abrir el documento y revisarlo</label>
                  <label className="tick"><input type="checkbox" /> Reescribir el perfil</label>
                  <label className="tick"><input type="checkbox" /> Enviarlo a una persona de confianza</label>
                </div>
              </div>
              <div className="sp-col">
                <p className="sp-t">Mis notas para la próxima sesión</p>
                <label htmlFor="notes" className="sr">Notas</label>
                <textarea id="notes" className="notes" rows={6} defaultValue="Me cuesta empezar por las mañanas. Quiero hablar de cómo sostener el paso cuando hay semanas difíciles." />
                <p className="ex-note">Patricia las ve antes de la sesión.</p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="sec" id="faq" style={{ paddingTop: 0 }}>
          <div className="wrap faq">
            <div>
              <p className="eyebrow fd">Preguntas frecuentes</p>
              <h2 className="rv" style={{ marginTop: 18 }}><span className="ln"><span>Antes de</span></span><span className="ln"><span><em>empezar.</em></span></span></h2>
            </div>
            <div>
              {[["¿Cuánto cuesta?", "150 € en un único pago por las tres sesiones. Si al terminar ves que necesitas más, se puede ampliar."],
                ["¿Qué incluye?", "Tres sesiones 1 a 1 con Patricia, con tu ejercicio de claridad como punto de partida. Ampliables si procede."],
                ["¿Cómo y cuándo son las sesiones?", "Eliges la fecha de inicio al reservar. El formato y la duración se confirman contigo al agendar."],
                ["¿Tengo que saber ya qué decisión tomar?", "No. El proceso sirve precisamente para ganar claridad y avanzar desde donde estás."],
                ["¿Patricia me dirá qué hacer?", "No. Te ayuda a ordenar lo que vives y a concretar un paso. La decisión sigue siendo tuya."],
                ["¿Esto sustituye atención psicológica?", "No. Es un acompañamiento para pasar a la acción, no terapia. Si estás en un momento difícil, acude a un profesional sanitario."],
                ["¿Qué pasa con mis datos?", "Se usan solo para enviarte tu ejercicio y gestionar tu solicitud. Puedes pedir su eliminación cuando quieras."]].map(([q, a], i) => (
                <details className="fd" key={q} open={i === 0}>
                  <summary>{q}<span className="pm" /></summary>
                  <p className="ans">{a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CIERRE */}
        <section className="sec close" style={{ paddingTop: 0 }}>
          <div className="wrap">
            <h2 className="rv"><span className="ln"><span>No necesitas sentirte</span></span><span className="ln"><span>completamente segura</span></span><span className="ln"><span><em>para empezar.</em></span></span></h2>
            <a className="btn btn-p mag" href="#ejercicio">Haz el ejercicio gratis <span className="ar" /></a>
          </div>
        </section>
      </main>

      {/* FOOTER */}
      <footer className="foot">
        <div className="wrap">
          <div className="foot-top">
            <p style={{ maxWidth: "34ch" }}>Acompañamiento 1 a 1 para dejar de posponer y dar el primer paso.</p>
            <nav>
              <a className="ul" href="#ejercicio">Ejercicio</a>
              <a className="ul" href="#reservar">Reservar</a>
              <a className="ul" href="mailto:info@patricialeung.com">Contacto</a>
              <Link className="ul" to="/privacidad">Privacidad</Link>
              <Link className="ul" to="/admin">Panel</Link>
            </nav>
          </div>
          <div className="giant" id="giant">Da el Paso</div>
          <div className="foot-b"><span>© {new Date().getFullYear()} Da el Paso</span><span>En español</span></div>
        </div>
      </footer>

      {/* BARRA MÓVIL */}
      <div className="mbar" id="mbar"><span><b>150 €</b> · 3 sesiones 1 a 1</span><a className="btn btn-p" href="#reservar">Reservar</a></div>

      {/* AYUDA */}
      <button className="help-b" id="helpB" type="button" aria-expanded="false" aria-controls="helpP">¿Dudas?</button>
      <div className="help-p" id="helpP" hidden>
        <p className="eyebrow">Ayuda rápida</p>
        <details><summary>¿Es terapia?</summary><p>No. Es un acompañamiento para pasar a la acción.</p></details>
        <details><summary>¿Y si no sé qué quiero cambiar?</summary><p>No hace falta. Empieza por el ejercicio gratis.</p></details>
        <details><summary>¿Puedo cambiar la fecha?</summary><p>Sí, escríbenos y lo reprogramamos.</p></details>
        <form id="callF" noValidate><label htmlFor="callE">¿Prefieres hablar antes? Déjanos tu email y te proponemos una llamada breve.</label><div className="f-row"><input id="callE" type="email" placeholder="tu@email.com" /><button className="btn btn-p" type="submit">Pedir</button></div></form>
      </div>

      {/* COOKIES */}
      <div className="cookie" id="cookie" hidden>
        <span>Usamos cookies técnicas y, si lo aceptas, de medición para mejorar la web. Puedes cambiarlo cuando quieras.</span>
        <div className="ck-btns"><button className="btn btn-g" type="button" data-ck="no">Solo técnicas</button><button className="btn btn-p" type="button" data-ck="yes">Aceptar</button></div>
      </div>

      <div className="toast" id="toast" role="status" />
    </>
  );
}
